module.exports = __webpack_public_path__ + "img/butel.3a0fdb07.png";